var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pill",class:{ start: _vm.start, end: _vm.end }},[_c('icon',{staticClass:"pill-icon",attrs:{"name":_vm.iconName,"variant":_vm.variant}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }